class Tooltip extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.innerHTML = `
    <div id='tooltip-template' style="display:none">
    <div class="tooltip-container">
      <span class="tp-cursor" style="cursor:pointer">
        <i class="fe fe-help-circle"></i>
      </span>
      <div class="tp-content" style="display:none"></div>
    </div>
  </div>
    `
  }
}

customElements.define('tooltip-component', Tooltip);